const useIsBrowser = typeof window !== 'undefined'

export default useIsBrowser
